import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { useTranslation } from 'react-i18next';
import { List, ListItem, ListItemText } from '@material-ui/core';
import PropTypes from 'prop-types';
import Divider from '@material-ui/core/Divider';
import getFullNameByLang from '../../../helpers/langHelpers';
import DialogContent from '../DialogContent';
import DialogActions from '../DialogActions';
import TitleTypography from '../../MUI/TitleTypography';
import CloseIcon from '../../../icons/Close';
import { efesBorder } from '../../../theme';

import useStyles from '../makeStyles';

const TravelersDialog = ({ travelers, onClose, open }) => {
  const { t, i18n } = useTranslation();
  const classes = useStyles();

  return (
    <Dialog
      fullWidth
      onClose={onClose}
      className={classes.root}
      aria-labelledby="travelers-dialog"
      open={open}
    >
      <DialogContent>
        <div className={classes.header}>
          <TitleTypography>
            {t('contract.summaryFields.travelers')}
          </TitleTypography>
          <div role="presentation" className={classes.closeIcon} onClick={onClose}>
            <CloseIcon color={efesBorder} />
          </div>
        </div>
        <List>
          {
            travelers.map((traveler) => (traveler.passport ? (
              <React.Fragment key={traveler.memberId}>
                <ListItem>
                  <ListItemText primary={getFullNameByLang(traveler, i18n.language)} />
                </ListItem>
                <Divider />
              </React.Fragment>
            ) : null))
          }
        </List>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onClose} color="primary">
          {t('menu.hide')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

TravelersDialog.propTypes = {
  travelers: PropTypes.arrayOf(PropTypes.shape({})),
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

TravelersDialog.defaultProps = {
  travelers: [],
};

export default TravelersDialog;
